// src/redux/voucherSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ACCOUNTS_URL } from "../Globalapi/Globalapi";

const initialState = {
  vouchers: [],
  loading: false,
  error: null,
};

export const fetchVouchers = createAsyncThunk(
  "vouchers/fetchVouchers",
  async (lgType) => {
    const response = await axios.post(
      `${ACCOUNTS_URL}/vouchers/voucher_show.php`,
      {
        lg_type: lgType, // Use the lgType parameter
        cmp_id: sessionStorage.getItem("cmp_id"), // Example value, update accordingly
      }
    );
    console.log("====================================");
    console.log(response);
    console.log("====================================");
    return response.data.data; // Assuming the data you need is in the `data` key
  }
);

const voucherSlice = createSlice({
  name: "vouchers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVouchers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVouchers.fulfilled, (state, action) => {
        state.vouchers = action.payload;
        state.loading = false;
      })
      .addCase(fetchVouchers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default voucherSlice.reducer;
